<template>
  <div class="how-it-works">
    <!-- How-It-Workes-Section-Start -->
    <section class="row_am how_it_works" id="how_it_work">
      <!-- container start -->
      <div class="container">
        <div class="how_it_inner">
          <div
            class="section_title"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="300"
          >
            <!-- h2 -->
            <h2><span>How Salt Works</span> — 3 Easy Steps</h2>
            <!-- p -->
            <p>
              Booking braids or managing clients has never been simpler.
            </p>
          </div>
          <div class="step_block">
            <!-- UL -->
            <ul>
              <!-- step -->
              <li>
                <div
                  class="step_text"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <h4>Create an Account</h4>
                  <div class="app_icon">
                    <a href="#"><i class="icofont-brand-android-robot"></i></a>
                    <a href="#"><i class="icofont-brand-apple"></i></a>
                    <a href="#"><i class="icofont-brand-windows"></i></a>
                  </div>
                  <p>Sign up as a Customer or Braiding Expert and set up your profile in minutes.</p>
                </div>
                <div class="step_number">
                  <h3>01</h3>
                </div>
                <div
                  class="step_img"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <img src="images/download_app02.jpg" alt="image" />
                </div>
              </li>

              <!-- step -->
              <li>
                <div
                  class="step_text"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <h4>Book or Get Booked</h4>
                  
                  <p>
                    Customers choose braid type, size, length, date, time, and stylist.
Braiders receive bookings and manage availability easily.
                  </p>
                </div>
                <div class="step_number">
                  <h3>02</h3>
                </div>
                <div
                  class="step_img"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <img src="images/create_account02.jpg" alt="image" />
                </div>
              </li>

              <!-- step -->
              <li>
                <div
                  class="step_text"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <h4>Chat, Pay & Relax</h4>
                  
                  <p>Chat inside the app, pay securely online, and enjoy a smooth appointment experience.</p>
                </div>
                <div class="step_number">
                  <h3>03</h3>
                </div>
                <div
                  class="step_img"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <img src="images/enjoy_app02.jpg" alt="image" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- container end -->
    </section>
    <!-- How-It-Workes-Section-end -->
  </div>
</template>

<script>
export default {
  name: "CountBox",
};
</script>
